import { Toolbar } from '@mui/material';
import React from 'react'


export function PageToolbar({children}: React.PropsWithChildren<{}>) {

  return (
    <Toolbar sx={{pb: 3}} disableGutters={true} variant="dense">
      {children}
    </Toolbar>
  )
}